module.exports = __webpack_public_path__ + "img/frase_balao.eb25f593.svg";